import { Spacer } from 'app/member/layouts/generic';
import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import SlidingNav from 'app/shared/nav/sliding/sliding';
import { Routes, Route } from 'react-router-dom';
import { MobilePushModule } from './mobile';
import { SenderIDModule } from './sender-id';
import { SMSModule } from './sms/_index';
import { MobilePushMessageViewPage } from './mobile/view';

const nav_items = () => [
  {
    title: 'SMS',
    path: `/messaging/sms`
  },
  {
    title: 'Mobile Push',
    path: `/messaging/mobile`
  },
  {
    title: 'Web Push',
    path: `/messaging/web`
  },
  {
    title: 'Sender ID',
    path: `/messaging/sender-ids`
  }
];

const ListPages = () => {
  return (
    <>
      <SlidingNav nav_items={nav_items()} />
      <Spacer multiple={4} />
      <Routes>
        <Route path="/sender-ids/*" element={<SenderIDModule />} />
        <Route path="/mobile/*" element={<MobilePushModule />} />
        <Route path="/web/*" element={null} />
        <Route path="/sms*" element={<SMSModule />} />
      </Routes>
    </>
  );
};

export const MessagingModule = () => {
  return (
    <PageContentWrapper>
      <Routes>
        <Route path="/mobile/:id" element={<MobilePushMessageViewPage />} />
        <Route path="/*" element={<ListPages />} />
      </Routes>
    </PageContentWrapper>
  );
};
